<template>
  <section class="index">
    <div class="container">
			<div class="gc-page-container">
      	<div class="container-center">

          <section class="gc-page-tmp">
            <div class="top-bg">
              <div class="top-bottom">
                <div class="top-title">我的点子<span>可转入微信零钱 {{currentMoney}} 元</span></div>
                <img src="../assets/img/tixian@2x.png" alt="" @click="onTapIcon">
              </div>
              <div class="top-point">{{ currentPoint }}<span>点</span></div>
            </div>
            <a href="javascript:void(0)" class="bg-btn zhuan" @click="onTapZhuan">转入微信零钱</a>
            <p class="top-notice" @click="onTapInfo">微信零钱体现须知</p>
          </section>

          <!-- 点子动态 -->
          <section class="gc-page" v-for="(item,index) in listData" :key="index">
              <div class="gc-headImg-ctx">
                <img class="gc-headImg" src="../assets/img/zhangdan@2x.png" />
              </div>
              <div class="gc-page-top done">
                <div class="done-status">交易成功</div>
              </div>
              <div class="gc-page-center">
								<template v-if="item.type == 1">
									<!-- 点子转微信零钱 -->
									<p class="gc-title">点子转微信零钱</p>
									<p class="gc-subtitle-red">-{{ item.point }}点</p>									
								</template>
								<template v-else>
									<p class="gc-nickname" v-if="item.surveyId">{{ item.surveyId }}</p>
									<p class="gc-title">{{ item.surveyName }}</p>
									<p class="gc-subtitle">获得{{ item.point }}点</p>
								</template>
              </div>
              <div class="gc-qrtime">创建时间：{{item.addTime}}</div>
              <!-- <div class="gc-qrcode">
                <div class="gc-qrcode-text" @click="onTapEnterBtn(index)">详情</div>
              </div> -->
          </section>
				</div>
      </div>
    </div>

    		<!-- 提醒弹窗 -->
		<div class="desWin" v-if="isShowIcon">
			<div>
				<img src="../assets/img/dianzixqicon@2x.png" alt="" @click="isShowIcon = false">
				<p>卖点子挣钱</p>
				<p>参加点子项目，挣取点子。</p>
				<p>100点转入微信零钱等于1元。</p>
				<p>点子数达到1000点即可转入微信零钱。</p>
			</div>
		</div>

		<!-- 提现须知弹窗 -->
		<div class="noticeWin" v-if="isShowInfo">
			<div>
				<h6>微信零钱提现须知</h6>
				<p>1、申请金额需大于等于10元。</p>
				<p>2、申请兑换成功最短周期为2个工作日。</p>
				<p>3、申请提现的微信账号必须是微信实名认证账号。</p>
				<p>4、提现时需填写与微信实名认证一致的真实姓名，如不一致，会导致提现失败。</p>
				<p>5、如有任何疑问，请在卖点子公众号内留言，我们会尽快处理。</p>
				<button @click="isShowInfo = false">我知道了</button>
			</div>
		</div>

		<!-- 点子不够弹窗 -->
		<div class="noEnoughWin" v-if="isShownoEnough" @click="isShownoEnough = false">
			<div>
				<h4>你尚没有足够点子可转入微信零钱</h4>
				<p>点子数达到1000点才可转入</p>
				<a @click="onTapDianzi">挣点子去</a>
			</div>
		</div>

    <!-- 提现弹窗 -->
		<div class="importWin" v-if="tixianDialogOne || tixianDialogTwo">
			<div class="point" v-if="tixianDialogOne">
				<div class="importWin-top-div">
					<img class="close left">
					<h4>点子转微信零钱</h4>
					<img src="../assets/img/close-area.png" class="close right" @click="closeTixianDialog">
				</div>
				
				<div class="my-idea">
					<div class="my-idea-t">我的点子：</div>
					<div class="dot">
						<div class="idea">{{ currentPoint }}</div>
						<div class="dot-dot">点</div>
					</div>
				</div>
				<div class="my-idea-y">
					<div class="my-idea-t">请输入需要转入点子数</div>
					<div class="money">可兑：<span class="money">{{ currentMoney }}</span>元</div>
				</div>
				<div class="tmp-dianzi">
					<input type="text" id='inputPoint' placeholder="0" v-model="inputPoint"/>
					<div class="input-under">点</div>
				</div>
				<div class="sec-err" v-if="isShowError">{{errAlertTxt}}</div>
				<div class="button" @click="onTapTixianConfirmBtn">确认</div>
			</div>
			<div class="checkName" v-if="tixianDialogTwo">
				<h4>首次提现，需核对您的姓名</h4>
				<input type="text" id="inputName" placeholder="请写您的姓名" v-model="inputNickname" />
				<p>请填写与微信实名认证一致的真实姓名</p>
				<p>如不一致，会导致提现失败</p>
				<div class="sec-err" v-if="isShowSecError">{{secErrAlertTxt}}</div>
				<div class="button" @click="onTapCheckNameBtn">确认</div>
			</div>
		</div>

    <!-- 提现后提示弹窗 -->
		<div class="checking" v-if="tixianVerifyVisiable">
			<div>
				<h4>提交审核中</h4>
				<div class="process">
					<p>已成功提交<span id="submitMoney">{{ result.money }}</span>元</p>
					<h6 class="subTime">提交时间：<span id="submitTime">{{ result.time }}</span></h6>
					<p>核对您的信息</p>
					<h6 class="name">姓名：<span id="submitName">{{ result.name }}</span></h6>
					<p>审核中，金额将会在2个工作日内打入您的微信零钱中，请等待！</p>
				</div>
				<button @click="tixianVerifyVisiable = false">确定</button>
			</div>
		</div>

  </section>
</template>

<script>
import { getCookie } from '../utils';

export default {
  data() {
    return {
      listData: [],
      isShowIcon: false,
      isShowInfo: false,
      currentPoint: 0,
      currentMoney: 0,
      isShownoEnough: false,
      tixianDialogOne: false,	// 显示输入框
      tixianDialogTwo: false,	// 显示输入用户名框
      inputPoint: '',		// 输入的点子数
      tixianVerifyVisiable: false,
      inputNickname: '',
      errAlertTxt: '',
      isShowError: false,
      result: {},
      secErrAlertTxt: '',
      isShowSecError: false,
      isDebounce: false
    }
  },

  mounted() {
		this.requestPoint();
		this.requestListExt();
  },

  methods: {
    // 当前点子数
    requestPoint() {
      let unionId = getCookie('unionId');
      this.$axios.get('https://home.51point.com/51point-0.0.1-SNAPSHOT//completion/getNumberOfIdeas', {params: {param: unionId}}).then(res => {
        console.log(res);
				if (res.data.data) {
					this.currentPoint = parseFloat(res.data.data).toFixed(0)
					this.currentMoney = (this.currentPoint / 100).toFixed(2)
				}else {
					this.currentPoint = 0;
					this.currentMoney = 0;
				}
      })
		},
		
		requestListExt() {
			let unionId = getCookie('unionId');
      this.$axios.get('https://home.51point.com/51point-0.0.1-SNAPSHOT/completion/exForPc', {params: {param: unionId}}).then(res => {
				console.log(res);
				let list = [];
				res.data.data.forEach(item => {
					let value = {};
					value.type = 1;
					value.unionId = item.unionId;
					value.point = item.point;
					value.money = item.money;
					value.nickName = item.nickName;
					value.addTime = item.addTime;
					value.isAdd = item.isAdd;
					value.id = item.id;
					list.push(value);
				})
				this.listData = list;
				this.requestPointList();
      })
		},

    // 点子动态
    requestPointList() {
      let unionId = getCookie('unionId');
      this.$axios.get('https://home.51point.com/51point-0.0.1-SNAPSHOT/completion/ideaDynamics', {params: {param: unionId}}).then(res => {
        console.log(res);
        res.data.data.forEach(item => {
          if (item.type == 2 && item.surveyName != '积分转微信零钱') {
            item.surveyName = '即付问卷';
          }
          if (item.surveyName == '积分转微信零钱') {
            item.surveyName = '点子转微信零钱';
					}
					item.type = 2;
        });
        this.listData = this.listData.concat(res.data.data);
      })
    },

    onTapIcon() {
      this.isShowIcon = true;
    },

    // 提现
    onTapZhuan() {
			// 判断点子是否够提现
      if (this.currentPoint < 1000) {
        this.isShownoEnough = true;
        return;
      }

      // 够提现，弹提现窗口
			this.tixianDialogOne = true
			this.isShowError = false
			this.inputPoint = ''
    },

    onTapTixianConfirmBtn() {
			if (this.inputPoint.length == 0) {
				// 没有输入
				this.errAlertTxt = '请输入要转入的点子数'
				this.isShowError = true
				return
			}
      const input = parseInt(this.inputPoint)
      if (isNaN(input)) {
        this.errAlertTxt = '输入的点子不合法，请输入大于0的数字'
				this.isShowError = true
				return
      }
			if (!input || input <= 0) {
				this.errAlertTxt = '输入的点子不合法，请输入大于0的数字'
				this.isShowError = true
				return
			}
			if (input > Number(this.currentPoint) || (input / 100) > Number(this.currentMoney)) {
				this.errAlertTxt = '输入的点子数超过了可以提现的点子数'
				this.isShowError = true
				return
			}
			if (input < 1000) {
				this.errAlertTxt = '每次兑换点子数不能少于 1000 点'
				this.isShowError = true
				return
			}
      this.isShowError = false;
      this.tixianDialogOne = false
      this.tixianDialogTwo = true
      this.isShowSecError = false
      this.secErrAlertTxt = ''
    },

    onTapCheckNameBtn() {
			if (this.inputNickname.length == 0) {
				this.secErrAlertTxt = '请输入真实姓名'
				this.isShowSecError = true
				return
			}
      
      let unionId = getCookie('unionId');
      this.$axios.get('completion/pointExchangeForPc', {params: {param: unionId, ideaNum: this.inputPoint ,nickname: this.inputNickname }}).then(res => {
          console.log(res);
          this.requestPoint();
          this.requestPointList();
          
          this.result.time = this.formatDate(new Date())
					this.result.name = this.inputNickname
					this.money = this.inputPoint / 100
          this.tixianVerifyVisiable = true
      })
    },

    formatDate(date) {
				let fmt = 'yyyy-MM-dd hh:mm'
				var o = {
					'M+': date.getMonth() + 1, //月份
					'd+': date.getDate(), //日
					'h+': date.getHours(), //小时
					'm+': date.getMinutes(), //分
					's+': date.getSeconds(), //秒
					'q+': Math.floor((date.getMonth() + 3) / 3), //季度
					S: date.getMilliseconds() //毫秒
				};
				if (/(y+)/.test(fmt)) {
					fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
				}
				for (var k in o) {
					if (new RegExp('(' + k + ')').test(fmt)) {
						fmt = fmt.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length));
					}
				}
				return fmt;
		},

    // 关闭点子不够弹窗
    onTapDianzi() {
      this.isShownoEnough = false;
      this.$router.push('/');
    },

    onTapInfo() {
      this.isShowInfo = true;
    },

    closeTixianDialog() {
			this.tixianDialogOne = false
			this.tixianDialogTwo = false
    }
  }
}
</script>

<style scoped>

.index .gc-qrcode-img{
  width:125px;
  height:125px;
  margin: 20px auto;
}
.index .wxssk{
  font-size: 12px;
  color: #666666;
  text-align: center;
}
.index .gc-qrcode-ctx{
  width: 160px;
  height: 200px;
  background: #FFFFFF;
  border: 1px solid #EFEFEF;
  box-shadow: 0 2px 5px 0 rgba(0,0,0,0.08);
  border-radius: 2px;
}
.index .gc-qrcode{
  position: absolute;
  bottom: 20px;
  right: 15px;
}

.index .gc-qrtime {
  position: absolute;
  bottom: 20px;
  left: 15px;
  font-size: 10px;
  color: #999;
}
.index .gc-qrcode-text{
  font-size: 13px;
  color: #959499;
  border: 1px solid #d8d8d8;
  border-radius: 2px;
  /* width: 60px; */
  padding-left: 10px;
  padding-right: 10px;
  height: 30px;
  text-align: center;
  line-height: 30px;
  float: right;
  margin-top: 10px;
  cursor: pointer;
}
.index .gc-qrcode-text:hover{
  background: #C9C9CE;
  border-color: #C9C9CE;
  color: #fff;
}
.index .gc-page{
  /* float:left; */
	margin-left: 10px;
	margin-right: 10px;
}
.index .gc-category{
  position: absolute;
  right: 15px;
  top:15px;
  z-index: 2;
  border-radius: 100px;
  background-color: rgba(0,0,0,.7);
  font-size: 11px;
  color: #FFFFFF;
  padding:5px;
}
.index .gc-page-bottom{
  position: absolute;
  bottom: 20px;
  z-index: 2;
  left: 15px;
  height: 16px;
  line-height: 16px;
  width: 150px;
  font-size: 12px;
  color: #9B9B9B;
}
.index .gc-headImg-ctx{
  position: absolute;
  top: 125px;
  left: 15px;
  z-index: 2;
  width:32px;
  height:32px;
}
.index .gc-headImg{
  width:32px;
  height:32px;
  border-radius: 32px;
  border: 2px solid #FFFFFF;
}
.index .gc-page-top{
  width: 280px;
  height: 140px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.index .gc-page-center{
  position: relative;
  padding:15px;
  padding-top: 25px;
}
.index .gc-nickname{
  font-size: 13px;
  color: #666666;
  margin-bottom: 15px;
}
.index .gc-title{
  font-size: 15px;
  color: #333;
  margin-bottom: 12px;
  line-height: 22px;
}
.index .gc-subtitle{
  font-size: 12px;
  color: #888888;
  line-height: 18px;
  /* max-height: 54px; */
  overflow: hidden;
}

.index .gc-subtitle-red {
	font-size: 12px;
  color: #F97C69;
  line-height: 18px;
  overflow: hidden;
}

.index .gc-page{
  width: 280px;
  height: 360px;
  background: #FFFFFF;
  /* cursor: pointer; */
  position: relative;
  margin-bottom: 20px;
}
.index .gc-page:hover{
  box-shadow: 0 10px 10px 0 rgba(0,0,0,0.08);
}
.index .container {
  min-height: 540px;
}


.index .gc-page-top img {
  width: 100%;
  height: 100%;
  background: gray;
}

.noQ {
	display: block;
	padding-top: 20px;
}

.noQ p {
	font-size: 14px;
	color: #666;
	text-align: center;
	line-height: 28px;
}

.noQ-div {
	width: 260px;
	height: 196.48px;
	margin: 0 auto;
	background-size: 360px 196.48px;
	padding-top: 22px;
	display: flex;
	flex-direction: column;
	align-items: center;
}

.noQ .noQ-link {
	color: #65AE71;
	border-bottom: 3px double #65AE71;
}

.noQ-btn {
	font-size: 16px;
	margin-top: 10px;
	color: white;
	/* background: #DF7F7D; */
	background:#65AE71;
	height: 40px;
	width: 120px;
	border-radius: 8px;
	display: flex;
	justify-content: center;
	align-items: center;
}

.noQ div:nth-of-type(2) {
	width: 47px;
	height: 77px;
	margin: 10px auto 0;
	background: url(../assets/img/zhanwuicon@2x.png) center no-repeat;
	background-size: 47px 77px;
}
.done {
  background: #9FC2E2;
}

.ing {
  background: #D4B7B5;
}

.done-status {
  position: relative;
  left: 100px;
  top: 118px;
  color: white;
}

.ing-status {
  position: relative;
  left: 115px;
  top:  110px;
  color: white;
}

.ing-status span {
  font-size: 160%;
  margin-right: 4px;
}

.index .gc-page-tmp{
  /* float:left; */
	margin-left: 10px;
	margin-right: 10px;
  width: 280px;
  height: 360px;
  background: #FFFFFF;
  /* cursor: pointer; */
  position: relative;
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.index .gc-page-tmp:hover{
  box-shadow: 0 10px 10px 0 rgba(0,0,0,0.08);
}

.top-bg {
  height: 50%;
  width: 100%;
  background: #65ae71;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
}

.bg-btn {
  width: 90%;
  height: 45px;
  color: white;
  display: block;
  border-radius: 4px;
  font-size: 15px;
  line-height: 45px;
  margin-top: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.zhuan {
  background: #65ae71;
}

.exit {
  background: #f16754;
}

.top-point {
  font-size: 48px;
  color: white;
  margin-bottom: 30px;
}

.top-point span {
  font-size: 15px;
  margin-left: 5px;
}

.top-title {
    font-size: 14px;
    color: #fff;
    margin-left: 10px;
}

.top-title span {
    opacity: .5;
    font-size: 12px;
    margin-left: 10px;
    color: #fff;
}

.top-bottom {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-top: 10px;
}

.top-bottom img {
  height: 18px;
  width: 18px;
  margin-right: 10px;
}

.top-notice {
    font-size: 14px;
    color: #999;
    text-align: center;
    margin-top: 10px;
}

/*点子描述弹层*/
.desWin {
	position: fixed;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	z-index: 1000;
	background: rgba(0, 0, 0, 0.5);
	padding: 9.1rem 1rem 0;
}

.desWin div {
	background: #fff;
	border-radius: 0.8rem;
	padding: 20px 17px 42px;
  position: relative;
  z-index: 1001;
  /* margin-left: 40%;
  margin-right: 40%; */
    -webkit-animation: fadeInDown .3s;
  animation: fadeInDown .3s;
}

.desWin div img {
	width: 14px;
	height: 14px;
	position: absolute;
	top: 12px;
	right: 12px;
	padding: 10px;
}

.desWin div p {
	font-size: 14px;
	color: #333;
	line-height: 26px;
	text-align: center;
}

.desWin div p:nth-of-type(1) {
	font-size: 18px;
	color: #1d1e23;
	margin-bottom: 14px;
}

/*点子提示须知*/
.noticeWin {
	position: fixed;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	z-index: 1000;
	background: rgba(0, 0, 0, 0.5);
	padding: 3.4rem 2rem 0;
}

.noticeWin div {
	padding: 18px 20px 39px;
	background: #fff;
  border-radius: 4px;
  /* margin-left: 40%;
  margin-right: 40%; */
  /* margin-top: 5%; */
    -webkit-animation: fadeInDown .3s;
  animation: fadeInDown .3s;
}

.noticeWin div h6 {
	font-size: 18px;
	color: #3e3e3e;
	text-align: center;
	margin-bottom: 14px;
}

.noticeWin div p {
	font-size: 14px;
	color: #3e3e3e;
	line-height: 22px;
}

.noticeWin div button {
	width: 100%;
	background: #65ae71;
	border-radius: 8px;
	margin-top: 30px;
	color: #fff;
	font-size: 14px;
	line-height: 44px;
}

/*点子不足*/
.noEnoughWin {
	position: fixed;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	z-index: 1000;
	background: rgba(0, 0, 0, 0.5);
	padding: 10px 2px 0;
}

.noEnoughWin div {
	background: #fff;
	border-radius: 4px;
  padding: 18px 45px 26px;
  /* margin: 10% 40%; */
  -webkit-animation: fadeInDown .3s;
  animation: fadeInDown .3s;
}

.noEnoughWin div h4 {
	font-size: 15px;
	color: #333;
	text-align: center;
	margin-bottom: 16px;
}

.noEnoughWin div p {
	font-size: 14px;
	color: #999;
	text-align: center;
	margin-bottom: 20px;
}

.noEnoughWin div a {
	display: block;
	font-size: 14px;
	text-align: center;
	color: #fff;
	background: #65ae71;
	border-radius: 8px;
  line-height: 44px;
  cursor: pointer;
}

/*提现输入电子数*/
.importWin {
	position: fixed;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	z-index: 1000;
	padding: 61px 20px 0;
	background: rgba(0, 0, 0, 0.5);
	border-radius: 4px;
}

.importWin-top-div {
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-between;
}

.close {
	width: 14px;
	height: 14px;
	border: 0;
}

.left {
	opacity: 0;
}

/*输入提现电子数*/
.point {
	background: #fff;
	border-radius: 4px;
  padding: 22px 20px 30px;
  /* margin: 5% 32%; */
  -webkit-animation: fadeInDown .3s;
  animation: fadeInDown .3s;
}

.point h4 {
	font-size: 18px;
	color: #333;
	text-align: center;
	margin-bottom: 20px;
}

.point p:nth-of-type(1) {
	font-size: 14px;
	color: #333;
	margin-bottom: 21px;
}

.my-idea {
	font-size: 14px;
	color: #333;
	margin-bottom: 21px;
	display: flex;
	flex-direction: row;
	align-items: flex-end;
}

.my-idea-y {
	font-size: 14px;
	color: #333;
	margin-bottom: 21px;
	display: flex;
	flex-direction: row;
	justify-content: space-between;
}

.my-idea-t {
	font-size: 14px;
	color: #333;
}

.dot {
	font-size: 24px;
	color: #65ae71;
	display: flex;
	flex-direction: row;
	align-items: flex-end;
}

.dot .dot-dot {
	font-size: 14px;
	margin-left: 4px;
	color: #65ae71;
}

.point p:nth-of-type(2) {
	font-size: 14px;
	color: #333;
	margin-bottom: 22px;
}

.point p:nth-of-type(2) text {
	display: inline-block;
	float: right;
	color: #65ae71;
}

.point p:nth-of-type(3) {
	border-bottom: 1px solid #ccc;
	padding-bottom: 8px;
}

.point p:nth-of-type(3) input {
	font-size: 36px;
	/* width: 28rem; */
	width: 100%;
}

.point p:nth-of-type(3) input::input-placeholder {
	color: #999;
}

.point p:nth-of-type(3) text {
	font-size: 14px;
	color: #333;
}

.point .button {
	font-size: 15px;
	color: #fff;
	background: #65ae71;
	border-radius: 8px;
	line-height: 44px;
	width: 100%;
  margin-top: 30px;
  display: flex;
  align-content: center;
  justify-content: center;
  cursor: pointer;
}

.check-btn {
	font-size: 15px;
	color: #fff;
	/* background: #65ae71; */
	background: #999;
	border-radius: 8px;
	/* line-height: 4.4rem; */
	height: 44px;
	width: 100%;
	margin-top: 35px;
	display: flex;
	justify-content: center;
	align-items: center;
}

.active {
	background: #65ae71; 
}

/*核对真实姓名*/
.checkName {
	padding: 19px 30px 29px;
	background: #fff;
  border-radius: 4px;
  /* margin: 5% 32%; */
    -webkit-animation: fadeInDown .3s;
  animation: fadeInDown .3s;
}

.checkName h4 {
	font-size: 16px;
	color: #333;
	margin-bottom: 20px;
	text-align: center;
}

.checkName input {
	font-size: 14px;
	/* width: 23.5rem; */
	width: 80%;
	/* height: 5rem; */
	height: 40px;
	border: 1px solid #d8d8d8;
	border-radius: 8px;
	padding-left: 10px;
	margin: 0 auto 10px;
	display: block;
}

.checkName p {
	text-align: center;
	font-size: 14px;
	line-height: 16px;
	color: #999;
}

.checkName .button {
	font-size: 15px;
	color: #fff;
	line-height: 44px;
	text-align: center;
	background: #65ae71;
	border-radius: 8px;
	margin-top: 30px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

#inputPoint {
  width: calc(100% - 20px);
  height: 40px;
  margin-bottom: 10px;
  border-radius: 4px;
  border: 1px solid #d8d8d8;
  padding: 0 10px;
}

/* WebKit browsers */
::-webkit-input-placeholder {
	color: #777;
}
/* Mozilla Firefox 4 to 18 */
:-moz-placeholder {
	color: #777;
	opacity: 1;
}
/* Mozilla Firefox 19+ */
::-moz-placeholder {
	color: #777;
	opacity: 1;
}
/* Internet Explorer 10+ */
:-ms-input-placeholder {
	color: #777;
}

.sec-err {
  background: #FEEDEE;
  color: #F46969;
  font-size: 12px;
  padding: 10px 20px;
  border-radius: 4px;
  margin-top: 20px;
}

/*提交审核中*/
.checking {
	position: fixed;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	z-index: 1000;
	background: rgba(0, 0, 0, 0.5);
	padding: 58px 20px 0;
}
.checking > div {
	background: #fff;
	border-radius: 0.4rem;
  padding: 20px 17px 22px 23px;
  /* margin: 5% 30%; */
    -webkit-animation: fadeInDown .3s;
  animation: fadeInDown .3s;
}

.checking > div h4 {
	font-size: 16px;
	color: #333;
	text-align: center;
	margin-bottom: 30px;
}
.process {
	padding-left: 30px;
	/* background: url(../img/shengheicon@2x.png) top left no-repeat; */
	background-size: 12px 150px;
	height: 177px;
	margin-bottom: 30px;
}

.process p {
	font-size: 14px;
	color: #65ae71;
	margin-bottom: 4px;
}

.process h6 {
	font-size: 12px;
	color: #999;
}

.subTime {
	margin-bottom: 34px;
}

.name {
	margin-bottom: 34px;
}

.checking button {
	font-size: 15px;
	color: #fff;
	background: #65ae71;
	border-radius: 4px;
	line-height: 45px;
	text-align: center;
	width: 100%;
}

@keyframes fadeInDown {
    0% {
        -webkit-transform: translate3d(0, -20%, 0);
        -webkit-transform: translate3d(0, -20%, 0);
        transform: translate3d(0, -20%, 0);
        transform: translate3d(0, -20%, 0);
        opacity: 0;
    }
    100% {
        -webkit-transform: none;
        transform: none;
        opacity: 1;
    }
}

.gc-page-container {
	display: flex;
	flex-direction: row;
	justify-content: center;
	margin: 0 auto;
}

.index .container-center{
  margin:0 auto;
  padding-top: 30px;
  overflow: hidden;
	display: flex;
	flex-direction: row;
	flex-wrap: wrap;
	justify-content: flex-start;
}

/* 手机 */
@media screen and (max-width: 768px) {
	.index .container-center {
		width: 300px;
	}
	.noEnoughWin div {
		margin: 10% 10px;
	}

	.desWin div {
		margin: 10% 10px;
	}

	.noticeWin div {
		margin: 10% 10px;
	}

	.checking > div {
		margin: 10% 10px;
	}

	.point {
		margin: 10% 10px;
	}

	.checkName {
		margin: 10% 10px;
	}
}

/* Pad */
@media screen and (min-width: 768px) and (max-width: 1023px) {
	.index .container-center {
		width: 600px;
	}

	.noEnoughWin div {
		margin: 10% 20%;
	}

	.desWin div {
		margin: 10% 20%;
	}

	.noticeWin div {
		margin: 10% 20%;
	}

	.checking > div {
		margin: 10% 20%;
	}
	.point {
		margin: 10% 20%;
	}

	.checkName {
		margin: 10% 20%;
	}
}

/* 中屏幕电脑 */
@media screen and (min-width: 1024px) and (max-width: 1199px) {
	.index .container-center {
		width: 900px;
	}

	.noEnoughWin div {
		margin: 10% 30%;
	}
	.desWin div {
		margin: 10% 30%;
	}
	.noticeWin div {
		margin: 10% 30%;
	}
	.checking > div {
		margin: 10% 30%;
	}
	.point {
		margin: 10% 30%;
	}

	.checkName {
		margin: 10% 30%;
	}
}

/* 大屏幕电脑 */
@media screen and (min-width: 1200px) {
	.index .container-center {
		width: 1200px;
	}

	.noEnoughWin div {
		margin: 10% 30%;
	}
	.desWin div {
		margin: 10% 30%;
	}
	.noticeWin div {
		margin: 10% 30%;
	}
	.checking > div {
		margin: 10% 30%;
	}
	.point {
		margin: 10% 30%;
	}

	.checkName {
		margin: 10% 30%;
	}
}

.red-txt {
	color: #F97C69;
}


</style>
